import { useEffect } from 'react';

import type { UseVisitsHistoryEffectsProps } from '@app/components/VisitsHistory/types';

export const useVisitsHistoryEffects = ({
  getClientRecordsHandler,
}: UseVisitsHistoryEffectsProps) => {
  useEffect(() => {
    getClientRecordsHandler();
  }, [getClientRecordsHandler]);
};
